import axios from 'axios'
import { ElMessage } from 'element-plus'
import store from '@/store'
import { serverUrl, AIManagementUrl } from '@/api/utils/baseURL.js'

// 创建axios实例
const service = axios.create({
  baseURL: "",
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('Token') || store.getters.token
    if (token) {
      config.headers['Token'] = `${token}`
    }
    //v1开头的是dify要带上头部
    if (config.url && config.url.startsWith("/v1/datasets")) {
      // config.headers['Authorization'] = "Bearer dataset-GlNDfHm81hyqvkgHyxxr9R5F"
      config.headers['Authorization'] = "Bearer dataset-skbniYRHhDanj7zRuvmg2oDK"
    } else if (config.url && config.url.startsWith("/v1")) {
      // config.headers['Authorization'] = "Bearer app-DWzbYOTZHJZ9Noh2FJaJ7kO5"
      config.headers['Authorization'] = "Bearer app-xIy7OMt5uuSQ3KwPkj6RjiwC"
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    // 根据业务状态码处理
    if ("code" in res && res.code !== 200 && res.code !== 1) {
      ElMessage({
        message: res.message || res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      // 特殊状态码处理
      if (res.code === 401 || res.code === 403) {
        handleUnauthorized()
      }
      const errMsg = res.message || res.msg || '请求失败'
      console.error('API请求错误:', errMsg, res)
      return Promise.reject(new Error(errMsg))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    // 处理HTTP状态码401
    if (error.response && error.response.status === 401) {
      handleUnauthorized()
    }
    // ElMessage({
    //   message: error.message || '请求失败',
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

function handleUnauthorized() {
  // 清理Vuex状态
  store.commit('setProjectForm', {});
  store.commit('setRouterForm', {});

  // 清理sessionStorage
  localStorage.removeItem('Token');
  localStorage.removeItem('ProjectForm');
  localStorage.removeItem('RouterForm');
  localStorage.removeItem('wss_uri');
  localStorage.removeItem('sip_uri');
  localStorage.removeItem('sip_password');
  localStorage.removeItem('Token');
  // 跳转登录页
  window.location.href = '/'
}

// 封装通用请求方法
export function request(options) {
  return service(options)
}

// 封装GET请求
export function get(url, params, options = {}) {
  return service({
    url,
    method: 'get',
    params,
    ...options
  })
}

// 封装POST请求
export function post(url, data, options = {}) {
  return service({
    url,
    method: 'post',
    data,
    ...options
  })
}

// 封装PUT请求
export function put(url, data, options = {}) {
  return service({
    url,
    method: 'put',
    data,
    ...options
  })
}

// 封装DELETE请求
export function del(url, params, options = {}) {
  return service({
    url,
    method: 'delete',
    params,
    ...options
  })
}

export default service